import * as _ from "lodash"
import { ExpressionCache } from "./ExpressionCache"

export class ExpressionUtils {
    private static _expCache: ExpressionCache = new ExpressionCache()

    static getAggregate<T>(
        sExpression: string,
        arrInputRecords: T[],
        symbolAccessor: (record: T, symbolId: string) => number,
    ): number {
        const ci = ExpressionUtils._expCache.get(sExpression)
        if (_.isEmpty(ci) || ci.error || _.isEmpty(arrInputRecords)) return undefined

        const aggValues: { [symbolId: string]: number } = {}
        for (const symbolId of ci.symbols) aggValues[symbolId] = 0

        for (const record of arrInputRecords) {
            for (const symbolId of ci.symbols) {
                const mtrValue = symbolAccessor(record, symbolId)
                aggValues[symbolId] += mtrValue || 0
            }
        }

        const results = ci.expressionFnc.evaluate(aggValues)

        return results
    }

    static getValue<T>(
        sExpression: string,
        record: T,
        symbolAccessor: (record: T, symbolId: string) => number | string,
    ): number | string {
        const ci = ExpressionUtils._expCache.get(sExpression)
        if (_.isEmpty(ci) || ci.error) return undefined

        const aggValues: { [symbolId: string]: number | string } = {}
        for (const symbolId of ci.symbols) aggValues[symbolId] = symbolAccessor(record, symbolId)
        const results = ci.expressionFnc.evaluate(aggValues)
        return results
    }
}
